import { Component, Input, ViewChild } from "@angular/core";
import { MultiselectComponent } from "./multiselect";

@Component({
    selector: "person-and-work-group-select",
    template: require('./person-and-work-group-select.component.html')
})
export class PersonAndWorkGroupSelect {

    constructor() {
        this.middleMarginTopPx = 0;
    }

    @Input()
    middleMarginTopPx: number;

    @Input()
    workgroups: Nema.Crew.Model.WorkGroup[];

    @Input()
    persons: Nema.Crew.Model.Person[];

    @Input()
    selectedPersons: Nema.Crew.Model.Person[];

    @Input()
    workGroupPersonIdSelector: (workGroup: Nema.Crew.Model.WorkGroup) => number[];

    @ViewChild('multiselect')
    personMultiSelect: MultiselectComponent;

    workGroupAdded(addedPersonIds: number[]): void {
        this.personMultiSelect.addItemsById(addedPersonIds);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/person-and-work-group-select.component.ts